//Functionality imports
import React, { useState } from 'react';
import './App.css';
import "@aws-amplify/ui-react/styles.css";
import { Authenticator, ThemeProvider, useTheme, View, Text, Heading, Button, useAuthenticator } from '@aws-amplify/ui-react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import SidebarMenu from './components/sidebarmenu_comp/sidebarmenu';
/* import { FaceLivenessDetector } from '@aws-amplify/ui-react-liveness';
import { ToggleButtonGroup, ToggleButton } from '@aws-amplify/ui-react'; */

//Components imports
import ChatPage from './pages/ChatPage/chat';
import ContactPage from './pages/ContactPage/contact';
import FAQPage from './pages/FAQPage/faqpage';
import UserProfile from './components/userprofile_comp/userprofile';
import TyCPage from './pages/TyCPage/tycpage';
import GuiaPage from './pages/GuiaPage/guiapage';
//customization imports
import logo from '../src/assets/img/logo-data-new.png';
import GeoPage from './pages/GeoPage/geopage';
import HomePage from './pages/HomePage/homepage';
import PlanPage from './pages/Plan/planpage';

// Custome Log in page
const components = {
  Header() {
    const { tokens } = useTheme();

    return (
      <View textAlign="center" padding={tokens.space.large}>
        <img src={logo} alt="Logo" className="login-logo" />
      </View>
    );
  },

  Footer() {
    const { tokens } = useTheme();

    return (
      <View textAlign="center" padding={tokens.space.large}>
        <Text color={tokens.colors.neutral[80]}>
          &copy; All Rights Reserved
        </Text>
      </View>
    );
  },

  SignIn: {
    Header() {
      const { tokens } = useTheme();

      return (
        <Heading
          padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
          level={3}
        >
          {/*   Welcome! Sign In to start */}
        </Heading>
      );
    },
    Footer() {
      const [showMessage, setShowMessage] = useState(false);
      const handleClick = () => {
        setShowMessage(!showMessage); // Muestra el texto al hacer clic
      };
      return (
        <View textAlign="center">
          <Button
            fontWeight="normal"
            onClick={handleClick}
            size="small"
            variation="menu"
          >
            Forgot your Password?
          </Button>
          {showMessage && <p>Contact DataBunker Human Advisor</p>}
        </View>
      );
    },
  },

  SignUp: {
    Header() {
      const { tokens } = useTheme();

      return (
        <Heading
          padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
          level={3}
        >
          Create a new account
        </Heading>
      );
    },
    Footer() {
      const { toSignIn } = useAuthenticator();

      return (
        <View textAlign="center">
          <Button
            fontWeight="normal"
            onClick={toSignIn}
            size="small"
            variation="link"
          >
            Back to Sign In
          </Button>
        </View>
      );
    },
  },
  ConfirmSignUp: {
    Header() {
      const { tokens } = useTheme();
      return (
        <Heading
          padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
          level={3}
        >
          Enter Information:
        </Heading>
      );
    },
    Footer() {
      return <Text>Footer Information</Text>;
    },
  },
  SetupTotp: {
    Header() {
      const { tokens } = useTheme();
      return (
        <Heading
          padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
          level={3}
        >
          Enter Information:
        </Heading>
      );
    },
    Footer() {
      return <Text>Footer Information</Text>;
    },
  },
  ConfirmSignIn: {
    Header() {
      const { tokens } = useTheme();
      return (
        <Heading
          padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
          level={3}
        >
          Enter Information:
        </Heading>
      );
    },
    Footer() {
      return <Text>Footer Information</Text>;
    },
  },
  ForgotPassword: {
    Header() {
      const { tokens } = useTheme();
      return (
        <Heading
        //padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
        //level={3}
        >
          Enter Information
        </Heading>
      );
    },
    Footer() {
      return <Text></Text>;
    },
  },
  ConfirmResetPassword: {
    Header() {
      const { tokens } = useTheme();
      return (
        <Heading
          padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
          level={3}
        >
          Enter Information:
        </Heading>
      );
    },
    Footer() {
      return <Text>Footer Information</Text>;
    },
  },
};
//Default values
const formFields = {
  signIn: {
    username: {
      placeholder: 'Enter your User',
    },
  },
  signUp: {
    password: {
      label: 'Password:',
      placeholder: 'Enter your Password:',
      isRequired: false,
      order: 1,
    },
    confirm_password: {
      label: 'Confirm Password:',
      order: 2,
    },
  },
  forceNewPassword: {
    password: {
      placeholder: 'Enter your Password:',
    },
  },
  forgotPassword: {
    username: {
      placeholder: 'Enter your email:',
    },
  },
  confirmResetPassword: {
    confirmation_code: {
      placeholder: 'Enter your Confirmation Code:',
      label: 'New Label',
      isRequired: false,
    },
    confirm_password: {
      placeholder: 'Enter your Password Please:',
    },
  },
  setupTotp: {
    QR: {
      totpIssuer: 'test issuer',
      totpUsername: 'amplify_qr_test_user',
    },
    confirmation_code: {
      label: 'New Label',
      placeholder: 'Enter your Confirmation Code:',
      isRequired: false,
    },
  },
  confirmSignIn: {
    confirmation_code: {
      label: 'New Label',
      placeholder: 'Enter your Confirmation Code:',
      isRequired: false,
    },
  },
};

/* //Custom Live Detector
const Customizationi18n = ({ onLivenessComplete }) => {
  const [language, setLanguage] = useState<string>('en');
  const [showLiveness, setShowLiveness] = useState(false);

  useEffect(() => {
    setShowLiveness(true);
  }, []);

  return (
    <View padding="large">
      <ToggleButtonGroup value={language} isExclusive onChange={(value) => setLanguage(value)}>
        <ToggleButton value="en">En</ToggleButton>
        <ToggleButton value="es">Es</ToggleButton>
      </ToggleButtonGroup>

      {showLiveness && (
        <FaceLivenessDetector
          sessionId={'sessionId'} // Aquí debes proporcionar un ID de sesión real.
          region="us-east-1"
          onAnalysisComplete={async () => {
            // Cuando el análisis de liveness se completa, llamar a onLivenessComplete
            onLivenessComplete();
          }}
          displayText={dictionary[language]}
        />
      )}
    </View>
  );
};
//Default values LiveDetector
const dictionary = {
  en: null,
  es: {
    photosensitivyWarningHeadingText: 'Advertencia de fotosensibilidad',
    photosensitivyWarningBodyText: 'Esta verificación muestra luces de colores. Tenga cuidado si es fotosensible.',
    goodFitCaptionText: 'Buen ajuste',
    tooFarCaptionText: 'Demasiado lejos',
    hintCenterFaceText: 'Centra tu cara',
    startScreenBeginCheckText: 'Comenzar a verificar',
  },
}; */

//App deployment
function App() {
  const [isSidebarVisible, setIsSidebarVisible] = useState(true); // Estado para controlar la visibilidad del menú lateral

  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible); // Función para mostrar/ocultar el menú
  };

  const { tokens } = useTheme();
  const theme = {
    name: 'Auth Theme',
    tokens: {
      components: {
        authenticator: {
          router: {
            boxShadow: `0 0 16px ${tokens.colors.overlay['10']}`,
            borderWidth: '0',
          },
          form: {
            padding: `${tokens.space.medium} ${tokens.space.xl} ${tokens.space.medium}`,
          },
        },
        button: {
          primary: {
            backgroundColor: tokens.colors.neutral['100'],
          },
          link: {
            color: tokens.colors.purple['80'],
          },
        },
        fieldcontrol: {
          _focus: {
            boxShadow: `0 0 0 2px ${tokens.colors.purple['60']}`,
          },
        },
        tabs: {
          item: {
            color: tokens.colors.neutral['80'],
            _active: {
              borderColor: tokens.colors.neutral['100'],
              color: tokens.colors.purple['100'],
            },
          },
        },
      },
    },
  };
  return (
    <ThemeProvider theme={theme}>
      <View padding="relative.medium">
        <Authenticator hideSignUp formFields={formFields} components={components}>
          {({ signOut }) => (
            <Router>
              <div className="app-container">
              <button
                className="hamburger-button"
                onClick={toggleSidebar}
              >
               ☰
              </button>
                <SidebarMenu 
                  isSidebarVisible={isSidebarVisible}
                  toggleSidebar={toggleSidebar}/>
                <div className={`content ${isSidebarVisible ? 'content-expanded' : 'content-collapsed'}`}>
                  <header className="app-header">
                    <div className="header-left">
                      <p className="app-title">AI Pricing Optimization Engine</p>
                    </div>
                    <div className="header-right">
                      <UserProfile />
                    </div>
                  </header>

                  <main className="app-main">
                    <Routes>
                      <Route path="/" element={<HomePage />} />
                      <Route path="/chat/:id_conversation" element={<ChatPage />} /> {/* Ruta con parámetro id_conversation */}
                      <Route path="/contact" element={<ContactPage />} />
                      <Route path="/faq" element={<FAQPage />} />
                      <Route path="/terms" element={<TyCPage />} />
                      <Route path="/guia" element={<GuiaPage />} />
                      <Route path="/plan" element={<PlanPage />} />
                      <Route path="/geo/:id_conversation" element={<GeoPage />} />
                    </Routes>
                  </main>
                </div>
              </div>
            </Router>
          )}
        </Authenticator>
      </View>
    </ThemeProvider>
  );
}

export default App;